import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import buildUrl from 'lib/buildUrl';
import { content as ContentPropType } from 'lib/CustomPropTypes';

import LeadBorderTop from 'components/LeadBorderTop';
import Link from 'components/Link';
import TeaseCard from 'components/TeaseCard';
import TypeIcon from 'components/TypeIcon';
import TeasePicture from 'components/TeasePicture';
import Unibrow from 'components/Unibrow';

import { hasFeaturedAuthor } from 'lib/featuredAuthor';
import { imageAltForImage } from 'lib/imageAlt';
import AIMS_FLAVORS from 'lib/aimsFlavors';

const mapStateToProps = ({ shared }) => ({
  vertical: shared.vertical,
});

@connect(mapStateToProps)
// TODO, detach this from TeaseCard (props, isNative())
class LeadOneUp extends TeaseCard {
  static propTypes = {
    content: ContentPropType,
    railAdjacent: PropTypes.bool,
    hasSibling: PropTypes.bool,
    pkgClassName: PropTypes.string,
  };

  static defaultProps = {
    railAdjacent: false,
    hasSibling: false,
    pkgClassName: 'pkg leadRectangle',
  };

  hasFeaturedAuthor() {
    const { item, type } = this.props.content;
    return hasFeaturedAuthor(item, type);
  }

  featuredAuthor() {
    if (!this.hasFeaturedAuthor()) {
      return null;
    }

    const { authors } = this.props.content.item;

    // below, intentional space after
    return (
      <span className="featuredAuthor lead-one-up__featured-author">
        { authors[0].person.name }
        {' '}
      </span>
    );
  }

  featuredAuthorImage() {
    if (!this.hasFeaturedAuthor()) {
      return null;
    }

    const { authors } = this.props.content.item;
    if (!authors[0].person.primaryImage) {
      return null;
    }

    return (
      <div className="lead-one-up__featured-author__image">
        <TeasePicture
          url={authors[0].person.primaryImage.url.primary} // might need to remove primary
          responsiveFlavors={{ s: AIMS_FLAVORS.FOCAL_380x380 }}
          alt={imageAltForImage(authors[0].person.primaryImage)}
        />
      </div>
    );
  }

  picture() {
    const { vertical, railAdjacent, content } = this.props;
    const { type, computedValues } = content;

    let responsiveFlavors = {
      s: AIMS_FLAVORS.FOCAL_758x379,
      m: AIMS_FLAVORS.FOCAL_580x580,
      l: AIMS_FLAVORS.FOCAL_760x380,
      xl: AIMS_FLAVORS.FOCAL_870x435,
    };

    if (vertical === 'today' || vertical === 'telemundoentretenimiento') {
      if (railAdjacent) {
        responsiveFlavors = {
          s: AIMS_FLAVORS.FOCAL_760x760,
          l: AIMS_FLAVORS.FOCAL_760x760,
        };
      } else {
        responsiveFlavors = {
          s: AIMS_FLAVORS.FOCAL_760x760,
          m: AIMS_FLAVORS.FOCAL_1000x500,
          l: AIMS_FLAVORS.FOCAL_760x380,
          xl: AIMS_FLAVORS.FOCAL_1000x500,
        };
      }
    }

    return (
      <TeasePicture
        responsiveFlavors={responsiveFlavors}
        type={type}
        computedValues={computedValues}
        placeholder
        placeholderColor="gray-40"
      />
    );
  }

  content() {
    const { content } = this.props;
    const {
      id, type, computedValues,
    } = content;
    const unibrow = computedValues ? computedValues.unibrow : content.unibrow;
    const { headline } = computedValues || {};

    const url = buildUrl(content);

    return (
      <article
        data-contentid={id}
        data-test="lead-one-up__content"
        className={classNames('lead-one-up__content', { 'layout-grid-item': !this.props.railAdjacent })}
      >
        <Link to={url} className="lead-one-up__picture">
          {this.picture()}
        </Link>

        <div className="lead-one-up__info">
          <div className="lead-one-up__info-inner">
            <TypeIcon
              type={type}
              url={url}
              className="lead-one-up__icon"
              iconLinkClass="lead-one-up__icon-link"
            />

            <span className="icon icon-quote-mark lead-one-up__quote" />

            <Unibrow
              className="lead-one-up__eyebrow"
              unibrow={unibrow}
            />

            <h2 className="lead-one-up__title">
              <Link to={url}>
                {this.featuredAuthor()}
                <span>
                  {headline}
                </span>
              </Link>
            </h2>

            <div className="lead-one-up__featured-author__image-wrapper">
              { this.featuredAuthorImage() }
            </div>
          </div>
        </div>
      </article>
    );
  }

  render() {
    if (!this.props.content) { return null; }

    const {
      packageId, railAdjacent, hasSibling, pkgClassName,
    } = this.props;
    const { packageIndex } = this.props.content;
    const classes = classNames(
      pkgClassName,
      `pkg-index-${packageIndex + 1}`,
      'lead-one-up',
      {
        'lead-one-up--sponsored': this.isNative(),
        'lead-one-up--rail-adjacent': railAdjacent,
        'lead-one-up--with-sibling': hasSibling,
      },
    );

    return (
      <section data-packageid={packageId} className={classes}>
        <LeadBorderTop types={['collectionLead']} />
        <div className={classNames('lead-one-up__wrapper', { 'layout-grid-container': !this.props.railAdjacent })}>
          { this.content() }
        </div>
      </section>
    );
  }
}

export default LeadOneUp;
